import React from 'react';
import FormControl, { FormControlProps } from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormMessage from './FormMessage';

export interface FormContainerProps extends FormControlProps {
  label?: string;
  message?: string;
  error?: boolean;
}

const FormContainer = (props: FormContainerProps) => {
  const { disabled, label, error, message, children, ...rest } = props;
  return (
    <FormControl disabled={disabled} error={error} margin="dense" {...rest}>
      {label && <FormLabel>{label}</FormLabel>}
      {children}
      <FormMessage error={error} message={message} />
    </FormControl>
  );
};

export default FormContainer;
